import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import configData from './Config.json';
import { useNavigate } from 'react-router-dom';
import TextArea from './Utils/textarea.js'
import Input from './Utils/input.js'

import Spinner from './Spinner.js';
import { isUnicode } from './Utils/text.js';

import placeholderimage from './Assets/profile/default.jpg';

import './Settings.css';

function Settings({ state, setState }) {
    const [openupload, setOpenupload] = useState(false);

    const [imagetoupload, setImageToUpload] = useState(null);
    const [preview, setPreview] = useState();

    const [userid, setUserid] = useState('');
    const [username, setUsername] = useState('');
    const [usernamedirectionrtl, setUsernamedirectionrtl] = useState(false);

    const [email, setEmail] = useState('');

    const [biography, setBiography] = useState('');
    const [biographydirectionrtl, setBiographydirectionrtl] = useState(false);
    const biographylimit = 150;

    const [showModal, setShowModal] = useState(false);

    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState();

    const profileImageRef = useRef(null);

    const history = useNavigate();

    useEffect(() => {
        setUserid(state.user.userid || '');
        setPreview(state.user.userprofilepicture || '');
        setEmail(state.user.useremail || '');
        setUsername(state.user.username || '');
        setBiography(state.user.userbiography || '');
    }, [state.user])

    function handleProfileImage() {
        profileImageRef.current.click();
    }

    function handleFileChange(event) {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            setImageToUpload(file);
            setPreview(reader.result);
        };
    }

    useEffect(() => {
        if (isUnicode(username)) {
            setUsernamedirectionrtl(true);
        } else {
            setUsernamedirectionrtl(false);
        }
    }, [username]);

    useEffect(() => {
        if (isUnicode(biography)) {
            setBiographydirectionrtl(true);
        } else {
            setBiographydirectionrtl(false);
        }
    }, [biography]);

    const handleSubmit = () => {
        console.log('Trying to update profile')

        if (username == '') {
            setResult('Please provide username')
            setLoading(false);
            return
        }

        if (username === state.user.username && biography === state.user.userbiography && !imagetoupload) {
            setResult('No changes were made');
            return;
        }

        setLoading(true);

        const updatemyprofileformdata = new FormData();
        updatemyprofileformdata.append('userid', userid);
        updatemyprofileformdata.append('username', username);
        updatemyprofileformdata.append('biography', biography);
        updatemyprofileformdata.append('file', imagetoupload);

        axios.post(configData.SECUREURL + configData.UPDATEMYPROFILE, updatemyprofileformdata, {
            headers: {
                "Content-Type": "multipart/form-data",
                "userid": state.user.userid,
                "usertoken": state.user.usertoken
            },
        }).then(res => {
            console.log('Update my profile data received')
            console.log(res.data)
            if (res.data instanceof Object) {
                if (res.data.code === 1) {
                    setResult('Success');
                    setState(state => ({ ...state, user: { ...state.user, userbiography: biography } }))
                    setState(state => ({ ...state, user: { ...state.user, username: username } }))
                }
                if (res.data.profilepicture) {
                    setState(state => ({ ...state, user: { ...state.user, userprofilepicture: res.data.newprofilepic } }))
                    setPreview(res.data.newImageName);
                }
            }
            else {
                setResult('Couldn\'t update profile');
            }
        }).catch((error) => {
            setResult(error.response)
        }).finally(() => {
            setLoading(false);
        })
    }

    const handleChangePassword = () => {
        setState(state => ({ ...state, modalopen: false, modalcontent: null, modaltype: null }));
        history('/authscreen?changepassword=true&uid=' + state.user.userid + '&t=' + state.user.usertoken)
    }

    const handleRemove = () => {
        setShowModal(true);
    };

    const handleConfirmRemove = () => {
        console.log('Remove my profile')
        setLoading(true);

        const data = {
            userid: state.user.userid
        };

        axios.post(configData.SECUREURL + configData.REMOVEMYPROFILE, data, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json;charset=UTF-8",
                "userid": state.user.userid,
                "usertoken": state.user.usertoken
            },
        }).then(res => {
            console.log('Received remove my profile data')
            console.log(res.data)
            if (res.data instanceof Object) {
                if (res.data.code === 1) {
                    setShowModal(false);
                    setResult('Successfully removed account');

                    setState(state => ({
                        ...state, user: {
                            userid: '',
                            usertoken: '',
                            usertype: 0,
                            useremail: '',
                            username: '',
                            userprofilepicture: '',
                            userbiography: '',
                        }
                    }))
                    localStorage.removeItem('user')
                }
                else {
                    setResult('Could not delete account');
                    setShowModal(false);
                }
            }
            else {
                setResult('Could not delete account');
                setShowModal(false);
            }
        }).catch((err) => {
            setResult(err.response?.data?.message || err.message || 'Network error');
        }).finally(() => {
            setLoading(false);
        })
    };

    const handleCancelRemove = () => {
        setShowModal(false);
    };

    const handleRemoveImage = () => {
        setPreview(null);
        setImageToUpload(null);

        console.log('Trying to remove my profile picture')

        const data = {
            userid: state.user.userid
        };

        axios.post(configData.SECUREURL + configData.REMOVEMYPROFILEPICTURE, data, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json;charset=UTF-8",
                "userid": state.user.userid,
                "usertoken": state.user.usertoken
            },
        }).then(res => {
            console.log('Received remove my profile picture data')
            console.log(res.data)
            if (res.data instanceof Object) {
                if (res.data.code === 1) {
                    setState(state => ({ ...state, user: { ...state.user, userprofilepicture: '' } }))
                }
                else {

                }
            }
            else {

            }
        }).catch((err) => {
            setResult(err.response?.data?.message || err.message || 'Network error');
        })
    };

    return (
        <div className='modal_body'>
            <div className='modal_printable'>
                <div className='settings'>
                    <div className='modal_row'>
                        {
                            preview ?
                                <img className='settings_profileimage' src={preview} alt="Preview Profile Picture" onClick={handleProfileImage} />
                                :
                                <img className='settings_profileimage' src={placeholderimage} alt="Profile Picture" onClick={handleProfileImage} />
                        }
                    </div>

                    <div className='modal_row'>
                        <div className='settings_removemyprofilepicturecontainer'>
                            <div className='button' onClick={handleRemoveImage}>Remove Picture</div>
                        </div>
                    </div>

                    <input
                        ref={profileImageRef}
                        type='file'
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                    />

                    <div className='modal_row'>
                        <Input value={username} setValue={setUsername} label='Username' type='text' length={5000} />
                    </div>

                    <div className='modal_row'>
                        <Input value={email} setValue={setEmail} disabled={true} label='Email' type='text' />
                    </div>

                    <div className='modal_row'>
                        <TextArea value={biography} setValue={setBiography} label='Description' length={150} />
                    </div>

                    <div className='modal_row'>
                        <Spinner loading={loading} size={50} />
                    </div>
                </div>
            </div>

            <div className='modal_actions'>
                {result && <div className='modal_result'>{result}</div>}
                <div className='modal_buttons'>
                    <div className='modal_buttoncontainer'>
                        <button className='modal_button' onClick={handleSubmit}>Update</button>
                    </div>
                    <div className='modal_buttoncontainer'>
                        <button className='modal_button' onClick={handleChangePassword}>Change Password</button>
                    </div>
                    <div className='modal_buttoncontainer'>
                        <button className='modal_button' onClick={handleRemove}>Remove Account</button>
                    </div>
                </div>
            </div>

            {
                showModal && (
                    <div className='settings_removeprofilemodal'>
                        <h2 className='settings_removeprofilemodaltitle'>Confirm remove account ?</h2>
                        <div>
                            <button className='modal_button' onClick={handleConfirmRemove}>Yes</button>
                            <button className='modal_button' onClick={handleCancelRemove}>No</button>
                        </div>
                    </div>
                )
            }
        </div>
    )
}

export default Settings;